<div tiimeForm [formGroup]="form">
  <div tiimeFormColumn>
    <app-generic-email-select
      [genericEmailControl]="form.from"
      [genericEmails]="froms()"
      label="De"
      required="true"
    ></app-generic-email-select>
    @if (displayTo) {
      <app-email-address-form
        label="A"
        [required]="true"
        [form]="form.to"
        [errorMessage]="form.toErrorMessage"
      ></app-email-address-form>
    }
    @if (displayCc) {
      <app-email-address-form label="Cc" [form]="form.cc"></app-email-address-form>
    }
    @if (displayCci) {
      <app-email-address-form label="Cci" [form]="form.cci"></app-email-address-form>
    }
    <tiime-input-container
      tiimeFormInputContainer
      contentId="subject"
      label="Sujet"
      required="true"
      [errorMessage]="form.subjectErrorMessage?.message"
    >
      <input
        type="text"
        formControlName="subject"
        placeholder="Objet"
        autocomplete="off"
        (keydown.enter)="$event.preventDefault()"
      />
    </tiime-input-container>
    @if (withRichTextEditor()) {
      <tiime-input-container
        class="content-input-container"
        [class.invalid]="form.bodyErrorMessage"
        contentId="content"
        label="Message"
        required="true"
        [errorMessage]="form.bodyErrorMessage?.message"
      >
        <tiime-rich-text-editor
          placeholder="Message"
          [formControl]="form.body"
          [isMarkdown]="false"
        ></tiime-rich-text-editor>
      </tiime-input-container>
    } @else {
      <tiime-input-container
        tiimeFormInputContainer
        contentId="body"
        label="Message"
        required="true"
        [errorMessage]="form.bodyErrorMessage?.message"
      >
        <textarea
          id="body"
          type="text"
          placeholder="Message"
          formControlName="body"
          debounce="800"
          [cdkAutosizeMinRows]="messageMinRows"
          [cdkTextareaAutosize]="autosize"
        ></textarea>
      </tiime-input-container>
    }

    <div class="attachments-container">
      @if (canSelectAttachments) {
        <app-multiple-attachments-selector [attachments]="form.attachments" [contractFileTypes]="contractFileTypes" />
      } @else {
        <mat-chip-list>
          @for (attachment of form.attachments.controls; track $index) {
            <app-attachment-item
              [canBeDeleted]="attachment.canBeDeleted.value"
              [attachmentName]="attachment.name.value"
              (remove)="onRemoveAttachment($index)"
            ></app-attachment-item>
          }
        </mat-chip-list>
      }
    </div>
    @if (displayAddAttachment) {
      <app-add-files-button [acceptedTypes]="acceptedTypes" (filesAdded)="onFilesAdded($event)"></app-add-files-button>
    }
  </div>
</div>
